import CheckBookingLatest from './CheckBookingLatest.vue'
import CheckBookingNext from './CheckBookingNext.vue'

export default {
  CheckBookingLatest,
  CheckBookingNext
}



// WEBPACK FOOTER //
// ./src/components/ex10/index.js